import { store } from 'Models/Store';
import { getMeasurementValueFromId } from 'Util/_HumanWritten/MeasurementUtils';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { VehicleBookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/VehicleBookingWizardData';

export const useIsVehicleSpaceExceeded = (vehicleSpacesAvailable: number, wizardData: BookingWizardData) => {
	if (wizardData.tabSelected !== 'vehicle' || !(wizardData.innerWizardData instanceof VehicleBookingWizardData)) {
		return false;
	}

	const innerWizardData = wizardData.innerWizardData as VehicleBookingWizardData;

	let vehicleSpaceToReserve = getMeasurementValueFromId(innerWizardData.vehicleLengthId);
	let trailerSpaceToReserve = innerWizardData.trailerCheckboxSelected
		? getMeasurementValueFromId(innerWizardData.trailerLengthId, true)
		: 0;

	const width = store.widths.find(x => x.id === innerWizardData.vehicleWidthId);
	if (width) {
		vehicleSpaceToReserve *= width.capacityMultiplier;
		trailerSpaceToReserve *= width.capacityMultiplier;
	}

	const totalSpaceToReserve = vehicleSpaceToReserve + trailerSpaceToReserve;

	return totalSpaceToReserve > vehicleSpacesAvailable;
};
